import { Observable } from 'rxjs';
import {
  ArrayVerificationOutcome,
  ICreditScoreConfig,
  ICreditScoreStatus,
  ICreditScoreUserToken,
  IStartAttemptResponse,
} from '@domain/interfaces/credit-score-array/credit-score-array.interface';

/**
 * Credit Score (Array) API. The member is identified server-side by the member token
 * (X-Member-Token), never by an id sent from here.
 */
export abstract class CreditScoreArrayGateway {
  abstract getStatus(): Observable<ICreditScoreStatus>;
  abstract getConfig(): Observable<ICreditScoreConfig>;
  abstract startAttempt(): Observable<IStartAttemptResponse>;
  /** Permitted with a mount when a bureau said no and the pass continues on the next one. */
  abstract reportOutcome(attemptId: number, event: ArrayVerificationOutcome, legIndex?: number, sectionName?: string): Observable<IStartAttemptResponse>;
  abstract confirmEnrollment(): Observable<ICreditScoreStatus>;
  /** Replaces the member's Array user so the identity form (DOB/SSN) can be filled in again. */
  abstract resetProfile(): Observable<ICreditScoreStatus>;
  abstract getUserToken(): Observable<ICreditScoreUserToken>;
}
